import { promiseHandler } from "../common/promise-handler"
import eventRegistry from "../common/event-registry"
import onlineManager from "../main/online/online-manager"
import { EventType } from "../common/enums"

export function initOnline(hstRtcEngine) {
  /**
   * 获取所有在线用户列表
   */
  hstRtcEngine.prototype.getOnlineUsers = function(callback) {
    // no exist callback return promise
    onlineManager.getOnlineUsers()
    if (!callback || !typeof callback === 'function') {
      return promiseHandler(EventType.EVENT_GET_ONLINE_USERS)
    } else {
      eventRegistry.on(EventType.EVENT_GET_ONLINE_USERS, (params) => {
        callback(params)
      })
    }
  };

  /**
   * 邀请其他用户加入分组
   * @param {*} params 
   */
  hstRtcEngine.prototype.invite = function(params) {
    onlineManager.invite(params);
    return promiseHandler(EventType.EVENT_INVITE);
  };

  /**
   * 呼叫（新协议）
   * @param {*} params 
   */
  hstRtcEngine.prototype.makeCall = function(params) {
    onlineManager.makeCall(params);
    return promiseHandler(EventType.EVENT_MAKE_CALL);
  };

  /**
   * 响应呼叫（新协议）
   * @param {*} params 
   */
   hstRtcEngine.prototype.replyCall = function(params) {
    onlineManager.replyMakeCall(params);
  };

  /**
   * 取消呼叫
   * @param {*} params 
   */
   hstRtcEngine.prototype.cancelCall = function(params) {
    onlineManager.cancelCall(params);
    return promiseHandler(EventType.EVENT_CANCEL_CALL);
  };

  /**
   * 结束呼叫
   * @param {*} params 
   */
   hstRtcEngine.prototype.finishCall = function(params) {
    onlineManager.finishCall(params);
    return promiseHandler(EventType.EVENT_FINISH_CALL);
  };

  /**
   * 响应邀请
   * @param {*} params 
   */
  hstRtcEngine.prototype.replyInvite = function(params) {
    onlineManager.replyInvite(params);
  };

  /**
   * 邀请方取消邀请协议
   * @param {*} params 
   */
  hstRtcEngine.prototype.cancelInvite = function(params) {
    onlineManager.cancelInvite(params);
    return promiseHandler(EventType.EVENT_CANCEL_INVITE);
  };

  /**
   * 设置本端在线自定义状态
   * @param {*} params 
   */
  hstRtcEngine.prototype.setCustomState = function(params) {
    onlineManager.setCustomState(params);
  };
}
